'use strict';

namespace Core.Customer {

    import DestinationContentCard = Core.Destinations.DestinationContentCard;

    class SignInDashboard {

        showDashboard: boolean;
        fetching: boolean;
        user: any|null = null;
        searches: any[] = [];
        destinations: DestinationContentCard[] = [];

        tileTemplates = {
            1: <string|null>null,
            2: <string|null>null,
            3: <string|null>null
        };

        tileModels = {
            1: <any|null>null,
            2: <any|null>null,
            3: <any|null>null
        };

        tileTypes = {
            1: <DashboardTileType|null>null,
            2: <DashboardTileType|null>null,
            3: <DashboardTileType|null>null,
            4: <DashboardTileType|null>null,
            5: <DashboardTileType|null>null
        };

        constructor (
            private $rootScope,
            private $scope: ng.IScope,
            private $q: ng.IQService,
            private customerDashboardService: CustomerDashboardService,
            private houseRecommender: any,
            private analytics: any,
            private currentUser: any
        ) {
            $scope.$on('auth:signin', () => {
                this.setDashboardState();
            });

            $scope.$on('auth:signout', () => {
                this.setDashboardState();
                this.user = null;
            });

            this.setDashboardState();
        }

        private setDashboardState(): void {
            // Set local scope user
            this.user = this.currentUser.get();
            // Show this dashboard if the user is NOT signed in
            this.showDashboard = !this.user.AnonSignedIn && !this.user.SignedIn;
            this.showDashboard && this.fetch();
        }

        private fetch(): void {
            this.fetching = true;

            this.resetData();

            // The sign-in card doesn't require data so we can load it immediately
            this.tileTypes[1] = DashboardTileType.InspirationalContent;
            this.tileTemplates[1] = this.customerDashboardService.getTemplateForPlaceholder(
                DashboardTileType.InspirationalContent
            );

            let promises: ng.IPromise<any>[] = [];

            // Get 2 recent searches
            promises.push(this.customerDashboardService.getRecentSearches(2));

            // Get recommended destinations
            promises.push(this.houseRecommender.getHouseRecs());

            this.$q.all(promises).then(([searches, destinations]) => {
                this.searches = searches;
                this.destinations = destinations;

                this.configureTiles().then(() => {
                    this.fetching = false;
                    this.customerDashboardService.trackDashboardLoad(null, this.tileTypes);
                });
            });

        }

        private configureTiles(): ng.IPromise<any> {
            let deferred = this.$q.defer();

            // Placeholder 1
            // Sign-in card
            // *** ALREADY SET ***

            // Placeholder 2
            // Searches[0] OR Destinations[0]
            let type: DashboardTileType;

            if (this.searches[0]) {
                // show the first search
                this.tileTypes[2] = DashboardTileType.Search;
                this.tileModels[2] = this.searches[0];
            } else {
                // show the first destination
                this.tileTypes[2] = DashboardTileType.Destination;
                this.tileModels[2] = this.destinations[0];
            }

            // Placeholder 3
            // Searches[1] OR Destinations[0] OR Destinations[1]
            if (this.searches[1]) {
                // show the second search
                this.tileTypes[3] = DashboardTileType.Search;
                this.tileModels[3] = this.searches[1];
            } else {
                // show a destination
                this.tileTypes[3] = DashboardTileType.Destination;
                if (this.tileTypes[2] === DashboardTileType.Search) {
                    // show the first destination which doesn't match the destination of the search
                    this.tileModels[3] = this.customerDashboardService.getDestinationExcludingSearch(
                        this.tileModels[2],
                        this.destinations);
                } else {
                    // show the second destination
                    this.tileModels[3] = this.destinations[1];
                }
            }

            // map the templates to the types
            _.forOwn(this.tileTypes, (type: DashboardTileType, key: string) => {
                if (type) {
                    this.tileTemplates[key] = this.customerDashboardService.getTemplateForPlaceholder(type);
                }
            });

            deferred.resolve();
            return deferred.promise;
        }

        private resetData(): void {
            // reset all data to initial state
            this.searches.length = 0;
            this.destinations.length = 0;

            // placeholder templates and models
            _.forOwn(this.tileTemplates, p => p = null);
            _.forOwn(this.tileModels, p => p = null);
            _.forOwn(this.tileTypes, p => p = null);
        }

        public getModelForPlaceholder(position: number): any[] {
            // We return the model in an array so that we can use ng-repeat
            // to declare a privately scoped model for the ng-included template
            return [this.tileModels[position]];
        }

        public tileClick(position: number): void {
            this.customerDashboardService.trackDashboardClick(position, this.tileTypes[position]);
        }
    }

    angular
        .module('core')
        .directive('signInDashboard', (): ng.IDirective => {
            return {
                restrict: 'E',
                scope: {},
                replace: true,
                controller: SignInDashboard,
                controllerAs: 'sid',
                bindToController: {
                },
                templateUrl: 'partials/customer/signindashboard'
            };
        });
}
